import React, { useMemo } from 'react'
import ArnicaMappingForm from './ArnicaMappingForm';
import ArnicaCredentialsForm from './ArnicaCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData, CellRenderers } from 'utils/tableUtils';
import { isEmpty } from 'lodash';

export default function ArnicaConfigListing(props) {
    const columns = useMemo(() => [{
        title: "Repository",
        dataIndex: "repositoryName",
        render: (repositoryName) => {
            if (isEmpty(repositoryName)) {
                return CellRenderers.VALUE_OR_NA();
            }

            try {
                // Parse JSON stringified array from backend
                const repositories = JSON.parse(repositoryName);

                // Join array elements with comma and use helper
                return columnRenderArrayData(repositories.join(','));
            } catch {
                // Fallback for old data or invalid JSON (backward compatibility)
                return repositoryName;
            }
        },
        width: 200
    }], []);

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={ArnicaMappingForm}
            CredentialsForm={ArnicaCredentialsForm}
            extraColumns={columns}
        />
    )
};